import React from 'react';

function hash(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) - h) + str.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h);
}

export function gradientForId(id) {
    const h1 = hash(id || 'x');
    const hueA = h1 % 360;
    const hueB = (hueA + 35 + (h1 % 30)) % 360;
    const startColor = `hsl(${hueA}, 80%, 65%)`;
    const endColor = `hsl(${hueB}, 75%, 55%)`;
    return `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`;
}

const GradientThumb = ({ id, imageUrl, className = '', style, children }) => {
    const background = imageUrl ? `url(${imageUrl}) center/cover no-repeat` : gradientForId(id);
    return (
        <div className={`gradient-thumb ${className}`} style={{ background, ...style }}>
            {children}
        </div>
    );
};

export default GradientThumb;
